import { ref } from 'vue';

export default () => {
  const uploadSummary = ref<any[] | null>(null);

  return {
    state: { uploadSummary },
    funcs: {}
  };
};
